import { Box, Text } from '@ghq-abi/design-system';
import { useTranslate } from '@tolgee/react';
import { ExtractedField } from '~/entities/MyTickets/utils/fieldExtractor';

interface DetailItemProps {
  field: ExtractedField;
}

export function DetailItem({ field }: DetailItemProps) {
  const { t } = useTranslate();

  const isTranslationKey = field.value?.startsWith('form.');
  const displayValue = isTranslationKey ? t(field.value) : field.value;
  const displayLabel = t(field.label, '');

  return (
    <Box>
      <Text css={{ fontSize: '$sm', color: '$black', marginBottom: '$1', fontWeight: '$medium' }}>
        {displayLabel}
      </Text>
      <Text
        css={{
          fontSize: '$sm',
          color: '$gray500',
          fontWeight: '$semibold',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {displayValue}
      </Text>
    </Box>
  );
}